import { render } from "./AdminEmails.vue?vue&type=template&id=4b31f2a1"
import script from "./AdminEmails.vue?vue&type=script&lang=js"
export * from "./AdminEmails.vue?vue&type=script&lang=js"

import "../styles/admin-tools.css?vue&type=style&index=0&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__